import {
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Text,
  Textarea,
  VStack,
} from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { useForm } from 'react-hook-form';

interface FormData {
  adminNote: string;
}

interface ResolveRecognitionFormProps {
  type: 'ct' | 'rpl';
  onSubmit: (data: FormData) => Promise<void>;
}

export function ResolveRecognitionForm({ type, onSubmit }: ResolveRecognitionFormProps) {
  const {
    handleSubmit,
    register,
    formState: { isSubmitting, errors },
  } = useForm<FormData>();

  const heading = type === 'ct' ? t`Resolve CT Request` : t`Resolve RPL Request`;

  return (
    <>
      <Flex align="center" justify="center" mb={4}>
        <Text textStyle="2xl" color="fg.default" fontWeight="semibold">
          {heading}
        </Text>
      </Flex>

      <form onSubmit={handleSubmit(onSubmit)}>
        <VStack spacing={4} align="stretch">
          <FormControl isInvalid={!!errors.adminNote}>
            <FormLabel>
              <Trans>Admin note</Trans>
            </FormLabel>
            <Textarea
              {...register('adminNote', {
                required: t`Please enter an admin note`,
              })}
              placeholder={t`Enter a note about the resolution...`}
              rows={4}
            />
            <FormErrorMessage>{errors.adminNote?.message}</FormErrorMessage>
          </FormControl>

          <Button isLoading={isSubmitting} type="submit" width="auto">
            <Trans>Resolve</Trans>
          </Button>
        </VStack>
      </form>
    </>
  );
}
